<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <section class="section-sts">
      <div class="title">
        <span>Stati Fattura STS</span>
      </div>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Stato</th>
              <th>Descrizione</th>
            </tr>
          </thead>
          <tbody>
            @for (stato of statiSTS; track stato) {
              <tr>
                <td>{{ stato[0] }}</td>
                <td>{{ stato[1] }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="section-sdi">
      <div class="title">
        <span>Stati Fattura SDI</span>
      </div>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Stato</th>
              <th>Descrizione</th>
            </tr>
          </thead>
          <tbody>
            @for (stato of statiSDI; track stato) {
              <tr>
                <td>{{ stato[0] }}</td>
                <td>{{ stato[1] }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('close')"
        (click)="onClose()"
      ></app-button>
    </div>
  </div>
</div>
